import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AuthService from "./services/authentication";
import { gtmInit } from "./data/gtm";

import Header from "./layout/header";
import Routes from "./Routes";
import { TransitionGuideProvider } from "./transition/TransitionGuideContext";
import TransitionGuideWidget from "./transition/TransitionGuideWidget";

function App() {
  useEffect(() => {
    gtmInit();
  }, []);

  return (
    <AuthService.ProvideAuth>
      <Router>
        <TransitionGuideProvider>
          <Header />
          <div
            id="app-container"
            className="app-container mx-auto w-full max-w-screen-xl p-4 font-inter"
          >
            <div className="main-wrapper">
              <Routes />
            </div>
          </div>
          <TransitionGuideWidget />
        </TransitionGuideProvider>
      </Router>
    </AuthService.ProvideAuth>
  );
}

export default App;
